/******/ (() => { // webpackBootstrap
/* eslint-disable */
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.buttonMinus = this.querySelector("button[name='minus']");
      this.buttonPlus = this.querySelector("button[name='plus']");
      this.sectionId = this.getAttribute('data-section-id');
      this.rules = this.getQuantityRules();

      this.onButtonClick = this.onButtonClick.bind(this);
      this.onInput = this.debounce(this.onInput.bind(this), 500);
      this.onCartAdded = this.onCartAdded.bind(this);
      this.onVariantUpdated = this.onVariantUpdated.bind(this);
    }

    connectedCallback() {
      this.buttonMinus?.addEventListener('click', this.onButtonClick);
      this.buttonPlus?.addEventListener('click', this.onButtonClick);
      this.input?.addEventListener('input', this.onInput);
      window.eventBus.on('cart:added', this.onCartAdded);
      window.eventBus.on('variant:updated', this.onVariantUpdated);

      // Ensure the hidden product-form quantity starts at the contextual MOQ.
      queueMicrotask(() => this.emitQuantityChange());
    }

    disconnectedCallback() {
      this.buttonMinus?.removeEventListener('click', this.onButtonClick);
      this.buttonPlus?.removeEventListener('click', this.onButtonClick);
      this.input?.removeEventListener('input', this.onInput);
      window.eventBus.off('cart:added', this.onCartAdded);
      window.eventBus.off('variant:updated', this.onVariantUpdated);
    }

    getQuantityRules() {
      const element = this.querySelector('[data-quantity-rules]');
      if (!element) return {};

      try {
        return JSON.parse(element.textContent);
      } catch (error) {
        console.error('Unable to parse quantity rules:', error);
        return {};
      }
    }

    get minimum() {
      return Math.max(parseInt(this.input.getAttribute('min'), 10) || 1, 1);
    }

    get increment() {
      return Math.max(parseInt(this.input.getAttribute('step'), 10) || 1, 1);
    }

    get maximum() {
      const value = this.input.getAttribute('max');
      if (value === null || value === '') return null;

      const maximum = parseInt(value, 10);
      return Number.isNaN(maximum) ? null : maximum;
    }

    normalizeQuantity(value) {
      let quantity = parseInt(value, 10);
      if (Number.isNaN(quantity)) return this.minimum;

      quantity = Math.max(quantity, this.minimum);
      const remainder = quantity % this.increment;

      // Round manual entries upward to the next valid catalog increment.
      if (remainder !== 0) quantity += this.increment - remainder;
      if (this.maximum !== null) quantity = Math.min(quantity, this.maximum);

      return quantity;
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      const direction = event.currentTarget.name === 'plus' ? 1 : -1;
      const currentValue = this.normalizeQuantity(this.input.value);

      let newValue = currentValue + direction * this.increment;
      newValue = Math.max(newValue, this.minimum);
      if (this.maximum !== null) newValue = Math.min(newValue, this.maximum);

      this.input.value = newValue;
      if (previousValue !== this.input.value) this.emitQuantityChange();
    }

    onInput() {
      this.input.value = this.normalizeQuantity(this.input.value);
      this.emitQuantityChange();
    }

    onVariantUpdated(data) {
      if (data.sectionId && data.sectionId !== this.sectionId) return;
      if (!data.variant?.id) return;

      const rule = this.rules[String(data.variant.id)];
      if (!rule) return;

      this.input.setAttribute('min', rule.min);
      this.input.setAttribute('data-min', rule.min);
      this.input.setAttribute('step', rule.increment);
      this.input.setAttribute('data-step', rule.increment);

      if (rule.max !== null) {
        this.input.setAttribute('max', rule.max);
        this.input.setAttribute('data-max', rule.max);
      } else {
        this.input.removeAttribute('max');
        this.input.removeAttribute('data-max');
      }

      this.setAttribute('data-variant-id', data.variant.id);
      this.input.value = rule.min;
      this.emitQuantityChange();
    }

    onCartAdded(data) {
      if (data.sectionId && data.sectionId !== this.sectionId) return;
      this.input.value = this.minimum;
      this.emitQuantityChange();
    }

    emitQuantityChange() {
      window.eventBus.emit('qty:change', {
        value: this.input.value,
        sectionId: this.sectionId
      });
    }

    debounce(callback, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => callback(...args), wait);
      };
    }
  });
}
/******/ })()
;
